export default __webpack_public_path__ + "static/media/pro-elevate-cbb-banner-1.d6d1eb8c.jpg";